<div class="container">
    <div class="row no-gutters">
        <div class="col-12">
            <div class="d-flex popup-head align-items-center">
                <div class="popup-title mr-auto pl-4" *ngIf="modelFlag === 'add'" translate> lblAddCampaignTemplate
                </div>
                <div class="popup-title mr-auto pl-4" *ngIf="modelFlag === 'edit'" translate>lblEditCampaignTemplate
                </div>
                <div class="popup-title mr-auto pl-4" *ngIf="modelFlag === 'view'" translate>lblViewCampaignTemplate
                </div>
                <div class="float-right">
                    <a class="close mr-3" (click)="OnClose()" translate>
                        <span class="" aria-hidden="true">&times;</span>
                    </a>
                </div>
            </div>

            <div class="card-accord  scrollbar">
                <div class="card-content">
                    <div class="row">
                        <div class="col-12">
                            <div class="row" [formGroup]="templateform">

                                <div class="col-3">
                                    <label for="service" translate>lblName <strong class="mlt6 required"> *
                                        </strong></label>
                                    <input type="text" formControlName="templateName" class="form-control">
                                    <div *ngIf="cf.templateName.touched && cf.templateName.errors"
                                        class="help-block text-danger mb-3">
                                        <em class="ft-alert-circle align-middle" aria-hidden="true"></em><span
                                            translate>lblTemplateNameIsRequired</span>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <label for="service" translate>lblChannel <strong class="mlt6 required"> *
                                        </strong></label>
                                    <ng-select [multiple]="false" class="w-100 disable-clear-all" [clearable]="false"
                                        [searchable]="false" formControlName="channel">
                                        <ng-option *ngFor="let item of channelTypeList" [value]="item.id" translate>
                                            {{ item.campaignViaCode }}
                                        </ng-option>
                                    </ng-select>
                                </div>
                                <div class="col-3">
                                    <label for="service" translate>lblSubject <strong class="mlt6 required"> * </strong>
                                    </label>
                                    <input type="text" class="form-control " formControlName="subject">
                                    <div *ngIf="cf.subject.touched && cf.subject.errors"
                                        class="help-block text-danger mb-3">
                                        <em class="ft-alert-circle align-middle" aria-hidden="true"></em><span
                                            translate>lblTemplateSubjectIsRequired</span>
                                    </div>
                                </div>
                                <div class="col-9 mt-4" *ngIf="!(modelFlag === 'view')">
                                    <label for="service" translate>lblTemplate <strong class="mlt6 required"> *
                                        </strong> </label>
                                    <quill-editor format= "html" formControlName="body" [modules]="options" *ngIf="cf.channel.value == channel.Email"></quill-editor>
                                    <textarea class="form-control" formControlName="body"
                                        *ngIf="cf.channel.value == channel.SMS" rows="8"></textarea>
                                    <div *ngIf="cf.body.touched && cf.body.errors" class="help-block text-danger">
                                        <em class="ft-alert-circle align-middle" aria-hidden="true"></em><span
                                            translate>lblTemplatebodyIsRequired</span>
                                    </div>
                                </div>
                                <div class="col-3 mt-5" *ngIf="!(modelFlag === 'view')">
                                    <label for="fieldDetails" translate>lblFieldDetails</label>
                                    <em class="fas fa-info-circle fa-lg ml-2"
                                        ngbTooltip="{{'lblHelp' | translate}}"></em>
                                    <div id="templateFields" class="template-fields">
                                        <ul class="mt-3">
                                            <li *ngFor="let item of templateFieldList">
                                                {{ '*|' + item + '|*' }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-9 mt-3" *ngIf="modelFlag === 'view'">
                                    <label for="service" translate>lblTemplate <strong class="mlt6 required"> *
                                        </strong> </label>
                                    <div class="border pad15 relative">
                                        <div [innerHTML]="cf.body.value"></div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
            <div class="p-3 bg-light pp-footer-top-brdr">
                <div class="row">
                    <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                        <button type="submit" class="btn btn-primary btn-lg mr-sm-2" (click)="AddTemplate()"
                            [disabled]="templateform.invalid" aria-label="Center Align" translate><em
                                class="far fa-save font16 align-top mr-2"></em> lblSaveChanges</button>
                        <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em
                                class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>